import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '男同交友', path: '/category/jiaoyou' },
      { name: '生活资讯', path: '/category/shenghuo' },
      { name: '健康指南', path: '/category/jiankang' },
      { name: '活动信息', path: '/category/huodong' },
      { name: '社群互动', path: '/category/shequn' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '口碑评价', path: '/about#reputation' },
      { name: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: '资讯热点', path: '/category/zixun' },
      { name: '常见问题', path: '/#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-base text-white"></i>
              </div>
              <span className="text-lg font-semibold tracking-tight text-foreground-950 font-[var(--font-heading)]">
                男同网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为男同群体打造的综合性平台，提供交友、社群互动、生活资讯、健康指南及活动信息。
              找到志同道合的伙伴，探索属于自己的精彩生活圈。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-[var(--font-heading)]">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 男同网 - 男同社群交友与资讯平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="邮箱">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}